import { bootToolPage } from '../lib/boot-tool'

bootToolPage('media-lab')

const queries = [
  '(pointer: fine)',
  '(pointer: coarse)',
  '(hover: hover)',
  '(hover: none)',
  '(prefers-color-scheme: dark)',
  '(prefers-reduced-motion: reduce)',
  '(prefers-contrast: more)',
  '(color-gamut: srgb)',
  '(color-gamut: p3)',
  '(color-gamut: rec2020)',
  '(dynamic-range: high)',
  '(video-dynamic-range: high)',
  '(orientation: landscape)',
  '(orientation: portrait)',
  '(display-mode: fullscreen)',
  '(forced-colors: active)',
]

const list = document.querySelector('[data-mq-list]')

function paint(): void {
  if (!list) return
  list.innerHTML = queries
    .map((q) => {
      const ok = window.matchMedia(q).matches
      return `<li><span class="mono">${q}</span><strong class="mq-state ${ok ? 'is-true' : 'is-false'}"><i></i>${ok ? 'TRUE' : 'FALSE'}</strong></li>`
    })
    .join('')
}

paint()
queries.forEach((q) => window.matchMedia(q).addEventListener('change', paint))

document.querySelector('[data-action="copy-mq"]')?.addEventListener('click', async () => {
  const truthy = queries.filter((q) => window.matchMedia(q).matches).join('\n')
  await navigator.clipboard.writeText(truthy)
  const button = document.querySelector<HTMLButtonElement>('[data-action="copy-mq"]')
  if (!button) return
  const label = button.textContent
  button.textContent = '✓'
  window.setTimeout(() => {
    button.textContent = label
  }, 1200)
})
